import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

// Rôles ayant accès aux écrans de type "back-office"
const STAFF_ROLES = ["admin", "responsable", "protocole", "securite",
                     "communication", "media", "moderator"];

export default function ProtectedRoute({ children, role, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return <div className="min-h-screen grid place-items-center text-foreground/60">Chargement…</div>;
  }

  // Pas connecté : redirige selon le type de page demandée
  if (!user) {
    const isStaffPage =
      (roles && roles.some((r) => STAFF_ROLES.includes(r))) ||
      (role && STAFF_ROLES.includes(role));
    return <Navigate to={isStaffPage ? "/admin/connexion" : "/membres/connexion"}
                     state={{ from: loc.pathname }} replace />;
  }

  // Liste explicite de rôles autorisés
  if (roles && roles.length > 0) {
    if (!roles.includes(user.role)) {
      // Redirige vers la page d'accueil interne par défaut
      return <Navigate to={STAFF_ROLES.includes(user.role) ? "/admin" : "/membres"} replace />;
    }
    return children;
  }

  // role unique : "admin" accepte aussi "responsable" (super-admin)
  if (role === "admin" && !["admin", "responsable"].includes(user.role)) {
    return <Navigate to={STAFF_ROLES.includes(user.role) ? "/admin" : "/membres"} replace />;
  }
  if (role && role !== "admin" && user.role !== role) {
    return <Navigate to="/" replace />;
  }
  return children;
}
